module.exports = __webpack_public_path__ + "static/media/test2.5d8d7ed2.png";